import styled from "styled-components";

// Контейнер с отзывами
export const ReviewsContainer = styled.div`
  margin: 0 auto;
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-left: 50px;
  justify-content: center;

  @media (max-width: 430px) {
    margin-left: 10px;
  }
`;

type ImageProps = {
  $img: string;
};

export const InnerContainer = styled.div<ImageProps>`
  margin: 0 auto;
  width: 100%;
  max-width: 1300px;
  height: 550px;
  border-radius: 30px;
  background-image: url(${(props) => props.$img});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

// Тег 3
export const Tag3 = styled.div`
  position: relative;
  font-family: "Avenir Next", sans-serif;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  padding: 3px 7px;
  border-radius: 20px;
  background-color: #bfdcf5;
  display: flex;
  max-width: 300px;
  box-sizing: border-box;
  @media (max-width: 430px) {
    margin-left: -10px;
  }
`;

// Контейнер для блока
export const Div = styled.div`
  display: flex;
`;

// Всплывающее окно (Popup)
export const PopupInner = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  width: 620px;
  margin: auto;
  padding: 60px;
  border-radius: 24px;
  background-color: white;
  z-index: 3000;
  margin-left: 360px;
  @media (max-width: 430px) {
    width: 100%;
    max-width: 373px;
    padding: 10px;
    margin: 10px;
  }
`;

// Основной контейнер для всплывающего окна
export const Popup = styled.div`
  position: absolute;
  display: none;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  z-index: 2000;
  padding-top: 50px;
`;

// Контейнер с флекс-расположением
export const PartFlex = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 72px;
  @media (max-width: 430px) {
    flex-direction: column;
  }
`;

// Всплывающее окно затемненное
export const Popup2 = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 3000;
  padding-top: 50px;
`;

// Кнопка закрытия рейтинга
export const Xratings = styled.div<ImageProps>`
  position: absolute;
  z-index: 5000;
  cursor: pointer;
  display: block;
  margin-left: 650px;
  font-size: 20px;
  top: 20px;
  right: 15px;
  width: 21px;
  height: 21px;
  background-image: url(${(props) => props.$img});
  background-repeat: no-repeat;
  background-position: center;
`;

// Кнопка для рейтинга
export const Btnratings = styled.a`
  display: block;
  margin: 0 auto;
  margin-top: 36px;
  padding: 5px 10px;
  width: 150px;
  background-color: white;
  color: black;
  border: 1px solid black;
  cursor: pointer;
  border-radius: 30px;
  text-align: center;
  font-size: 20px;
  font-family: "Avenir Next", sans-serif;
  text-decoration: none;
  margin-bottom: 40px;
  transition: all 0.2s ease-in-out;
  &:hover {
    background-color: black;
    color: white;
    border-color: black;
  }
`;
